module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_vtrusguard_jp.58df470337bd35087f89a146a56d1bd8.png";